var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-tabs',[_c('vs-tab',{attrs:{"label":_vm.$tc('message.salaryProject.tabs', 0)}},[_c('Employees')],1),_c('vs-tab',{attrs:{"label":_vm.$tc('message.salaryProject.tabs', 1)}},[_c('Payouts')],1),(false)?_c('vs-tab',{attrs:{"label":_vm.$tc('message.salaryProject.tabs', 2)}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }